

export const FETCH_ALL_USER_IVES = 'FETCH_ALL_USER_IVES'



// WEBPACK FOOTER //
// ./src/CustomerInvoices/constants/index.js